<template>
  <el-form-item :label="i18nt('designer.setting.minDate')">
    <el-date-picker type="date" v-model="optionModel.minDate" @change="selectDateChanged" format="YYYY-MM-DD" value-format="YYYY-MM-DD" style="width: 100%"></el-date-picker>
  </el-form-item>
</template>

<script>
import { onMounted, reactive, toRefs } from 'vue';
import { useI18n } from '@/utils/i18n';
export default {
  name: 'minDate-editor',
  props: {
    designer: Object,
    optionModel: Object,
    selectedWidget: Object,
  },
  setup(props) {
    const { i18nt } = useI18n();

    return {
      i18nt,
      ...toRefs(props),
    };
  },
};
</script>

<style scoped></style>
